import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { getUrlLocale } from '../../utils/getUrlLocale';
import englishTrans from './locales/en/translation.json';
import englishUKTrans from './locales/en-UK/translation.json';
import englishAUTrans from './locales/en-AU/translation.json';
import spanishTrans from './locales/es/translation.json';
import portugTrans from './locales/pt/translation.json';
import frenchTrans from './locales/fr/translation.json';
import portugBRTrans from './locales/pt-BR/translation.json';
import portugPTTrans from './locales/pt-PT/translation.json';
import deutschTrans from './locales/de/translation.json';
import italianTrans from './locales/it/translation.json';
import dutchTrans from './locales/nl/translation.json';
import danishTrans from './locales/da/translation.json';
import spanishARTrans from './locales/es-AR/translation.json';
import spanishBOTrans from './locales/es-BO/translation.json';
import spanishCLTrans from './locales/es-CL/translation.json';
import spanishCOTrans from './locales/es-CO/translation.json';
import spanishCRTrans from './locales/es-CR/translation.json';
import spanishDOTrans from './locales/es-DO/translation.json';
import spanishECTrans from './locales/es-EC/translation.json';
import spanishSVTrans from './locales/es-SV/translation.json';
import spanishGTTrans from './locales/es-GT/translation.json';
import spanishHNTrans from './locales/es-HN/translation.json';
import spanishMXTrans from './locales/es-MX/translation.json';
import spanishNITrans from './locales/es-NI/translation.json';
import spanishPATrans from './locales/es-PA/translation.json';
import spanishPYTrans from './locales/es-PY/translation.json';
import spanishPETrans from './locales/es-PE/translation.json';
import spanishUYTrans from './locales/es-UY/translation.json';
import spanishVETrans from './locales/es-VE/translation.json';
import spanishESTrans from './locales/es-ES/translation.json';
import englishNZTrans from './locales/en-NZ/translation.json';
import englishEUTrans from './locales/en-EU/translation.json';


const resources = {
  en: {
    translation: englishTrans
  },
  'en-GB': {
    translation: englishUKTrans
  },
  'en-NZ': {
    translation: englishNZTrans
  },
  'en-EU': {
    translation: englishEUTrans
  },
  'en-AU': {
    translation: englishAUTrans
  },
  es: {
    translation: spanishTrans
  },
  'pt-BR': {
    translation: portugBRTrans
  },
  'pt-PT': {
    translation: portugPTTrans
  },
  fr: {
    translation: frenchTrans
  },
  pt: {
    translation: portugTrans
  },
  de: {
    translation: deutschTrans
  },
  it: {
    translation: italianTrans
  },
  nl: {
    translation: dutchTrans
  },
  da: {
    translation: danishTrans
  },
  'es-AR': {
    translation: spanishARTrans
  },
  'es-BO': {
    translation: spanishBOTrans
  },
  'es-CL': {
    translation: spanishCLTrans
  },
  'es-CO': {
    translation: spanishCOTrans
  },
  'es-CR': {
    translation: spanishCRTrans
  },
  'es-DO': {
    translation: spanishDOTrans
  },
  'es-EC': {
    translation: spanishECTrans
  },
  'es-SV': {
    translation: spanishSVTrans
  },
  'es-GT': {
    translation: spanishGTTrans
  },
  'es-HN': {
    translation: spanishHNTrans
  },
  'es-MX': {
    translation: spanishMXTrans
  },
  'es-NI': {
    translation: spanishNITrans
  },
  'es-PA': {
    translation: spanishPATrans
  },
  'es-PY': {
    translation: spanishPYTrans
  },
  'es-PE': {
    translation: spanishPETrans
  },
  'es-UY': {
    translation: spanishUYTrans
  },
  'es-VE': {
    translation: spanishVETrans
  },
  'es-ES': {
    translation: spanishESTrans
  },
};

const resolveLocale = (candidate) => {
  if (resources[candidate]) return candidate;
  const base = candidate.slice(0, 2);
  if (resources[base]) return base;
  return 'en';
};

let locale = 'en';
let fallbackLng = 'en';
if (typeof window !== 'undefined' && window.Shopify && window.Shopify.locale && window.Shopify.country) {
  let raw = window.Shopify.locale + '-' + window.Shopify.country;
  if (raw.length > 5) {
    raw = raw.substring(0, raw.length - 3);
  }
  locale = resolveLocale(raw);
  fallbackLng = window.Shopify.locale;
  sessionStorage.setItem('locale', locale);
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: [fallbackLng, 'en'],
    lng: locale,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json'
    },
  });

// WI #8320 — Force `en-GB` ONLY when the URL is also `/en/` (not e.g. `/de/`
// + GB country). The URL prefix is authoritative; a GB country selector with
// a non-English URL must NOT override the URL locale.
if (typeof window !== 'undefined') {
  const sessionCountry = sessionStorage.getItem('country');
  const userSelectedLanguage = sessionStorage.getItem('userSelectedLanguage');
  const urlLocale = getUrlLocale('lower');
  if (sessionCountry === 'GB' && !userSelectedLanguage && urlLocale === 'en') {
    i18n.changeLanguage('en-GB');
  }
}

export default i18n;
